const STORAGE_KEY = 'iuli_show_product_nf_copy_section';

export const PRODUCT_FORM_PREFS_CHANGED = 'iuliProductFormPrefsChanged';

export function getShowProductNfCopySection() {
  if (typeof window === 'undefined') {
    return true;
  }
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw === null) {
    return true;
  }
  return raw === '1' || raw === 'true';
}

export function setShowProductNfCopySection(show) {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(STORAGE_KEY, show ? '1' : '0');
  window.dispatchEvent(new CustomEvent(PRODUCT_FORM_PREFS_CHANGED));
}
